import {create} from "zustand";

const useGatePassStore = create((set) => ({
    isGatePassCreated: false,
    isGatePassStatusUpdated: false,
    isVehicleAddedToBooking: false,
    isOrgVehicleAddedToBooking: false,

    setGatePassCreated: (status) => set({isGatePassCreated: status}),
    setGatePassStatusUpdated: (status) => set({isGatePassStatusUpdated: status}),
    setVehicleAddedToBooking: (status) => set({isVehicleAddedToBooking: status}),
    setOrgVehicleAddedToBooking: (status) => set({isOrgVehicleAddedToBooking: status}),
}));

export default useGatePassStore